import React from 'react';
import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types';
import { FieldArray, Form, reduxForm } from 'redux-form';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import PanelTabs from './PanelTabs';
import CategoryDetailPanelContainer from './CategoryDetailPanelContainer';
import { thirdPageValidations } from './validations';

export function ThirdPage({
  categoryDetails,
  categoryOptions,
  dispatch,
  error,
  handleSubmit,
  previousPage,
  pristine,
  selectCategory,
  selectedCategory,
  submitting
}) {
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <h2 id="partner-contact-form-heading">
            Affiliate/Publisher Interest Questionnaire
            <br />
            <small className="smaller block">
              {'For each of the verticals you selected, please provide the information below. ' +
                'Please note that these need to be verticals where you are currently generating calls. ' +
                'Your answers will help us determine the best ways to work together. ' +
                'Once we have received your completed information, ' +
                'we will contact you regarding next steps.'}
            </small>
          </h2>
        </Col>
      </Row>
      <hr />
      <Row
        className="margin-bottomgap20"
        style={{ verticalAlign: 'text-bottom' }}
      >
        <Col xsOffset={3} xs={6} className="margin-topgap15 legend-markers">
          <span className="pull-left">
            <span style={{ marginRight: '20px' }}>
              <FontAwesome
                name="check-circle"
                tag="i"
                style={{ color: 'green' }}
              />
              {' Completed Verticals'}
            </span>
            <span>
              <FontAwesome
                name="exclamation-circle"
                tag="i"
                style={{ color: 'red' }}
              />
              {' Information still required'}
            </span>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={3} style={{ paddingRight: '0px', marginTop: '25px' }}>
          <PanelTabs
            categoryDetails={categoryDetails}
            categoryOptions={categoryOptions}
            hasErrorsArray={error}
            selectCategory={selectCategory}
            selectedCategory={selectedCategory}
          />
        </Col>
        <Col xs={9} style={{ paddingLeft: '0px' }}>
          <FieldArray
            categoryOptions={categoryOptions}
            categoryDetails={categoryDetails}
            component={CategoryDetailPanelContainer}
            dispatch={dispatch}
            name="category_details"
            selectedCategory={selectedCategory}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ButtonGroup className="pull-right">
            {/* eslint-disable jsx-a11y/tabindex-no-positive */}
            <Button bsStyle="warning" onClick={previousPage} tabIndex="10">
              <FontAwesome name="chevron-left" tag="i" />
              {' Back'}
            </Button>
            <Button
              bsStyle="success"
              disabled={pristine || submitting}
              tabIndex="11"
              type="submit"
            >
              {/* eslint-enable jsx-a11y/tabindex-no-positive */}
              <FontAwesome name="paper-plane" tag="i" />
              {' Submit'}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  );
}

ThirdPage.propTypes = {
  categoryDetails: arrayOf(shape({})).isRequired,
  categoryOptions: arrayOf(shape({})).isRequired,
  dispatch: func.isRequired,
  error: oneOfType([arrayOf(string), string]),
  handleSubmit: func.isRequired,
  previousPage: func.isRequired,
  pristine: bool.isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({}).isRequired,
  submitting: bool.isRequired
};

ThirdPage.defaultProps = {
  error: []
};

export default reduxForm({
  form: 'partnerSubmissionForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: thirdPageValidations
})(ThirdPage);
